import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import PrimaryButton from '@components/PrimaryButton';
import {
  useStyles,
  useStylesConfirmDeleteOrder,
  useStylesDeclineDeleteOrder,
} from './styles';

export default function TransitionsModal({ open, handleClose, handleDel }) {
  const classes = useStyles();
  const classesConfirmDeleteOrder = useStylesConfirmDeleteOrder();
  const classesDeclineDeleteOrder = useStylesDeclineDeleteOrder();

  const { t } = useTranslation(['ordersScreen', 'common', 'button']);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 5000,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Typography component="h6" className={classes.delMessage}>
              {t('areYouSure')}
            </Typography>
            <div className={classes.BtnContainer}>
              <PrimaryButton
                text={t('no')}
                classesButton={classesDeclineDeleteOrder}
                handleClick={handleClose}
              />
              <PrimaryButton
                text={t('yes')}
                classesButton={classesConfirmDeleteOrder}
                handleClick={handleDel}
              />
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
